import React from "react"
import { PlusOutlined, ImportOutlined } from "@ant-design/icons"

import { hasAccess } from "@components/Authorization"

const LABEL_CREATE = "Create"
const LABEL_IMPORT = "Import"


const useHeaderActions = ({
    selectableActions = [],
    openCreateInvestmentModal,
    openInvestmentsImportModal
}) => {
  const canCreateInvestments = hasAccess(['investments-write'])

  if (!canCreateInvestments) {
    return []
  }

  return [
    ...selectableActions,
    {
      icon: <PlusOutlined />,
      action: openCreateInvestmentModal,
      title: LABEL_CREATE,
    },
    {
      icon: <ImportOutlined />,
      action: openInvestmentsImportModal,
      title: LABEL_IMPORT,
    },
  ]
}

export default useHeaderActions
